"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _inventory = require("@/api/inventory");
var _parsing = require("@/utils/parsing");
var _Unpack = _interopRequireDefault(require("@/views/inventory/operations/inStock/Unpack.vue"));
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Index',
  components: {
    Unpack: _Unpack.default
  },
  data: function data() {
    return {
      list: [],
      queryParams: {
        barcode: '',
        name: '',
        maxStockQty: undefined,
        minStockQty: undefined,
        limit: 20,
        page: 1
      },
      total: 0
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    getList: function getList() {
      var _this = this;
      var params = (0, _parsing.filterValidParams)(this.queryParams);
      (0, _inventory.inventoryList)(params).then(function (response) {
        _this.total = response.total;
        _this.list = response.list;
      });
    },
    onQuery: function onQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    onReset: function onReset() {
      this.$refs.queryFormRef.resetFields();
      this.onQuery();
    },
    onPageChange: function onPageChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    onSizeChange: function onSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },
    onUnpack: function onUnpack(row) {
      this.$refs.unpackRef.open(row);
    }
  }
};